/**
 * Class Member Authentication
 *
 * Determines whether a validated class member is authorized for the portal
 * they are submitting on, and provides one-shot session carry-through so an
 * NLCM member who validates on /payment-election can be auto-redirected and
 * auto-logged-in on /nlcm-payment-election without re-entering credentials.
 */

const NLCM_AUTOLOGIN_KEY = "nlcmAutoLogin";
const NLCM_AUTOLOGIN_TTL_MS = 60_000;

export function classMemberAuth(data, portal) {
    const isNlcm = Boolean(data?.nlcmClassMember);
    const canEdit = Boolean(data?.nlcmCanEdit);

    const dispatch = {
        payment_election: () => {
            if (isNlcm && canEdit) {
                return { action: "redirect", target: "/nlcm-payment-election" };
            }
            if (isNlcm || canEdit) {
                return { action: "error" };
            }
            return { action: "allow" };
        },
        nlcm_payment_election: () => {
            if (isNlcm && canEdit) return { action: "allow" };
            return { action: "error" };
        },
    };

    if (portal && dispatch[portal]) {
        return dispatch[portal]();
    }
    return { action: "error" };
}

export function writeNlcmAutoLogin(zero_zero_id, confirmation_code) {
    try {
        sessionStorage.setItem(
            NLCM_AUTOLOGIN_KEY,
            JSON.stringify({
                zero_zero_id,
                confirmation_code,
                expiresAt: Date.now() + NLCM_AUTOLOGIN_TTL_MS,
            })
        );
        return true;
    } catch {
        return false;
    }
}

export function consumeNlcmAutoLogin() {
    try {
        const raw = sessionStorage.getItem(NLCM_AUTOLOGIN_KEY);
        if (!raw) return null;
        sessionStorage.removeItem(NLCM_AUTOLOGIN_KEY);
        const parsed = JSON.parse(raw);
        if (!parsed?.zero_zero_id || !parsed?.confirmation_code) return null;
        if (typeof parsed.expiresAt !== "number" || parsed.expiresAt < Date.now()) return null;
        return {
            zero_zero_id: parsed.zero_zero_id,
            confirmation_code: parsed.confirmation_code,
        };
    } catch {
        return null;
    }
}
